import { Outlet } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { Logo } from '@/components/layout/Logo';
import { RouteTabs } from '@/components/ui/RouteTabs';

/**
 * docs/ARCHITECTURE.md §1.3: Owner Console is a separate top-level area,
 * not nested inside the guild dashboard's layout — no server selector, no
 * 13-section sidebar. This layout is intentionally visually distinct (a
 * persistent warning-toned header bar) so no one mistakes it for a normal
 * guild-scoped page. Real OWNER_IDS-based gating doesn't exist until real
 * auth ships (Phase 3+) — until then this area is shown to anyone, clearly
 * labeled as an unauthenticated preview.
 */
export function OwnerLayout() {
  return (
    <div className="h-full flex flex-col">
      <div className="bg-warning/10 border-b border-warning/40 px-4 py-2 flex items-center gap-2 text-warning text-small">
        <ShieldAlert size={16} aria-hidden="true" />
        Owner Console — platform-wide, bot-owner-only tooling. Not guild-scoped.
      </div>
      <header className="h-14 flex items-center px-4 border-b border-border-subtle bg-bg-surface">
        <Logo />
        <span className="ml-3 text-small text-text-tertiary">/ Owner Console</span>
      </header>
      <div className="px-4 md:px-6 pt-4">
        <RouteTabs
          accent="settings"
          tabs={[
            { to: '/owner', label: 'Overview', end: true },
            { to: '/owner/announcements', label: 'Announcements' },
            { to: '/owner/ai', label: 'AI Diagnostics' },
          ]}
        />
      </div>
      <main className="flex-1 overflow-y-auto p-4 md:p-6">
        <Outlet />
      </main>
    </div>
  );
}
